<main>
    <div class="d-flex flex-row justify-content-center admin-page-header">
        <h1 class="admin-page-title">
            FAQs
        </h1>
    </div>

    <div class="mediumContainer">
        @if (loading || !loading && faqs.length == 0) {
            <div aria-live="polite" class="w-100 d-flex flex-col align-items-center" role="status">
                @if (loading) {
                    <mat-spinner aria-label="Loading FAQs" color="primary"></mat-spinner>
                }
                @if (!loading && faqs.length == 0) {
                    <div class="illustrated-empty-state">
                        <img src="assets/images/reading-character.png" width="431" height="422"
                             alt="Yellow character reading a book">
                        @if (loadFailed) {
                            <h2>We couldn't load the FAQs</h2>
                            <p>Please refresh the page to try again.</p>
                        } @else {
                            <h2>Nothing here just yet</h2>
                            <p>No FAQs are available for your account right now. Please check back later.</p>
                        }
                    </div>
                }
            </div>
        }
        <mat-accordion>
            @for (question of faqs; track question) {
                <mat-expansion-panel (expandedChange)="this.authService.refreshUser();"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <strong>{{ question.title }}</strong>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div [innerHTML]="question.content" class="faqDesc"></div>
                    @if (question.attachment || question.link) {
                        <div class="flex-row flex-space-around mt-10">
                            @if (question.attachment) {
                                <button (click)="link(question.attachment, false, question.attachment)"
                                        (keyup.enter)="link(question.attachment, false, question.attachment)"
                                        color="primary" mat-raised-button>Download Attachment
                                </button>
                            }
                            @if (question.link) {
                                <button (click)="link(question.link, false, question.link_title)"
                                        (keyup.enter)="link(question.link, false, question.link_title)"
                                        color="primary" mat-raised-button>{{ question.link_title }}
                                </button>
                            }
                        </div>
                    }
                </mat-expansion-panel>
            }
        </mat-accordion>

    </div>
</main>
